/* eslint-disable no-restricted-globals */
/* eslint-disable no-nested-ternary */
import "./index.css";
import PropTypes from "prop-types";
import React, { useEffect, useRef } from "react";
import { Separator } from "./Separator";
import { SkinsBar } from "./SkinsBar";
// import { nameInitials } from "./nameInitials";
import { matchValues } from "./matchValues";
import { uniqueId } from "./uniqueId";
import { checkPrevAndTotal } from "./checkPrevAndTotal";
import Best2BestBallBar from "./best2BestBallBar";
import { backgroundHolesColor } from "./backgroundHolesColor";
import { holeAndRes } from "./holeAndRes";
import { addSign } from "./addSign";
import { holeResults } from "./holeResults";

function ScorecardItem({
  users,
  onHoleClicked,
  final,
  hasOwnProperty,
  teeTimeTime,
  skins,
  quota,
  carryOver,
  ballCount,
  teamsPlay,
  matchType,
  secondBetMatchType,
  // eslint-disable-next-line no-unused-vars
  isSecondBetQuota,
  currentHoleIndex,
}) {
  const holeRefs = useRef(null);

  useEffect(() => {
    if (currentHoleIndex !== null && holeRefs.current[currentHoleIndex]) {
      holeRefs.current[currentHoleIndex]?.scrollIntoView({
        behavior: "smooth",
        block: "center",
        inline: "center",
      });
    }
  }, [currentHoleIndex]);

  const {
    showBestBallTitle,
    BallValue,
    calculateNetScore,
    showTotalBarDependsMatchType,
    grosNetStringTeamTotal,
    showTwoBestBallDependsMatchType,
    showAsterik,
  } = matchValues();

  const totalBarDependsMatchType = () => {
    if (secondBetMatchType === 0) {
      return false;
    }
    return showTotalBarDependsMatchType[matchType] || quota;
  };

  const array18 = new Array(18).fill(0);

  const holesResult = holeResults(users);

  return (
    <div
      style={{ display: "flex", flexDirection: "row" }}
      className="scorecardItem--wrapper"
    >
      <div>
        {hasOwnProperty && (
          <div>
            <div
              className="scorecardItem--title-secondary"
              style={{ paddingLeft: 16, backgroundColor: "#ECF3FA" }}
            >
              Hole
            </div>
            <div
              className="scorecardItem--title-secondary semibold"
              style={{ paddingLeft: 16 }}
            >
              Par
            </div>
          </div>
        )}
        {!teamsPlay && (
          <Separator
            showTime={false}
            teeTime={teeTimeTime}
            teeTimeString={users?.[0].teeTimeString || null}
          />
        )}

        {users.map((i, idx) => {
          const {
            checkPrevTeeTimeString,
            checkPrevTeamName,
            showTotal,
            checkNextTeamName,
            hideTotalForOnePlayer,
          } = checkPrevAndTotal(idx, i, users);

          return (
            <React.Fragment key={uniqueId()}>
              {final && checkPrevTeeTimeString && (
                <Separator
                  showTime={false}
                  teeTimeString={i.teeTimeString ?? null}
                />
              )}
              {checkPrevTeamName && (
                <Separator showTime={false} teeTimeString={i.teamName} />
              )}
              <div
                style={{
                  width: 150,
                  height: 44,
                  backgroundColor: idx % 2 ? "white" : "#ECF3FA",
                  flexDirection: "column",
                  display: "flex",
                  justifyContent: "center",
                  paddingLeft: 16,
                }}
                key={uniqueId()}
              >
                <div className="scorecardItem--name">
                  {/* {nameInitials(i.displayName)} */}
                  {i.displayName}
                </div>
                {/* <div className="scorecardItem--description">
                  {!quota && `DHCP ${i.courseHandicap}`}
                  {quota && `QUOTA ${i.quota}`}
                </div> */}
              </div>
              {totalBarDependsMatchType() &&
                showTotal &&
                checkNextTeamName &&
                hideTotalForOnePlayer &&
                ballCount !== 1 && (
                  <div
                    style={{
                      height: 48,
                      display: "flex",
                      justifyContent: "center",
                      flexDirection: "column",
                      alignItems: "center",
                      backgroundColor: "#EFEFEF",
                    }}
                  >
                    <div
                      style={{
                        textTransform: "uppercase",
                        fontFamily: "SF Pro Text",
                        fontWeight: 700,
                        fontSize: 12,
                        // lineHeight: 18,
                        color: "rgba(30, 38, 46, 0.6)",
                      }}
                    >
                      {i.teamName} {grosNetStringTeamTotal[matchType]}
                    </div>
                    {showBestBallTitle[matchType] && (
                      <div
                        style={{
                          // textTransform: "uppercase",
                          fontFamily: "SF Pro Text",
                          fontWeight: 300,
                          fontSize: 9,
                          // lineHeight: 18,
                          color: "rgba(30, 38, 46, 0.6)",
                        }}
                      >
                        with {BallValue[ballCount]}
                      </div>
                    )}
                  </div>
                )}
              {showTwoBestBallDependsMatchType &&
                hideTotalForOnePlayer &&
                checkNextTeamName &&
                ballCount === 1 && (
                  <Best2BestBallBar
                    showTitleBar
                    teamName={i.teamName}
                    net={calculateNetScore[matchType]}
                  />
                )}
            </React.Fragment>
          );
        })}
        {final && skins && (
          <div
            style={{
              minHeight: 32,
              maxHeight: 32,
              width: "100%",
              backgroundColor: "rgba(30, 38, 46, 0.9)",
              justifyContent: "flex-start",
              alignItems: "center",
              display: "flex",
              paddingLeft: 16,
              fontFamily: "SF Pro Text",
              fontWeight: 500,
              fontSize: 13,
              lineHeight: 18,
              color: "white",
            }}
          >
            SKINS
          </div>
        )}
      </div>
      <div
        style={{
          display: "flex",
          flexDirection: "row",
          overflowX: "auto",
          whiteSpace: "nowrap",
          overflowY: "hidden",
        }}
      >
        {array18?.map((el, index) => (
          <div
            ref={(e) => {
              if (!holeRefs.current) {
                holeRefs.current = [];
              } // Проверяем, что current не null
              holeRefs.current[index] = e;
            }}
            // eslint-disable-next-line react/no-array-index-key
            key={index}
            style={{
              flexDirection: "column",
              flexShrink: 0,
              justifyContent: "center",
              alignItems: "center",
              display: "flex",
            }}
            aria-hidden="true"
            type="button"
            onClick={() => onHoleClicked(index)}
          >
            {hasOwnProperty && (
              <div
                style={{
                  width: "100%",
                }}
              >
                <div
                  className="scorecardItem--hole-text"
                  style={{
                    backgroundColor: "#ECF3FA",
                    width: "100%",
                    display: "flex",
                    flexDirection: "column",
                    alignItems: "center",
                    justifyContent: "center",
                  }}
                >
                  {`#${index + 1}`}
                </div>
                <div
                  className="scorecardItem--hole-text semibold"
                  style={{
                    width: "100%",
                    display: "flex",
                    flexDirection: "column",
                    alignItems: "center",
                    justifyContent: "center",
                  }}
                >
                  {users[0].holes?.[index]?.holePar ?? "-"}
                </div>
              </div>
            )}
            {!teamsPlay && <Separator showTime={false} />}

            {users?.map((user, ix) => {
              const {
                checkPrevTeeTimeString,
                checkPrevTeamName,
                showTotal,
                checkNextTeamName,
                hideTotalForOnePlayer,
              } = checkPrevAndTotal(ix, user, users);

              const groupedData = users.reduce((acc, curr) => {
                (acc[curr.teamName] = acc[curr.teamName] || []).push(curr);
                return acc;
              }, {});

              const sum1 = (r, a) => r.map((b, i) => a[i] + b || null);
              const smallestNumber = (r, a) =>
                r.map((b, i) => Math.min(a[i], b) || null);

              const matrixGross = groupedData[users[ix]?.teamName]?.map((uu) =>
                uu.holes.map((hole) => hole.score),
              );

              const matrixNet = groupedData[users[ix]?.teamName]?.map((uu) =>
                uu.holes.map((hole) => hole.netScore),
              );

              const matrixQuota = groupedData[users[ix]?.teamName]
                ?.map((uu) => uu.holes.map((hole) => hole.quota))
                .reduce(sum1);

              const test = (r, a) => r.map((b, i) => a[i] !== b || null);

              const highlightWinScore =
                (!skins &&
                  matchType !== 0 &&
                  matrixNet?.reduce(test)[index] &&
                  user.holes[index].netScore ===
                    matrixNet?.reduce(smallestNumber)?.[index]) ||
                null;

              const { skinsHoleBool, quotaRes, res } = holeAndRes(
                user,
                index,
                skins,
                showAsterik[matchType],
                highlightWinScore,
              );

              const backgroundHoles = backgroundHolesColor(
                skinsHoleBool,
                ix,
                highlightWinScore,
              );

              const sum2Smallest = (arr) =>
                arr
                  .reduce((acc, curr) => {
                    curr.forEach((value, arrIndex) => {
                      if (acc[arrIndex] === undefined) {
                        acc[arrIndex] = [];
                      }
                      if (value !== null) {
                        acc[arrIndex].push(value);
                      }
                    });
                    return acc;
                  }, [])
                  .map((column) => {
                    const sortedColumn = column.sort((a, b) => a - b);
                    return sortedColumn[0] + sortedColumn[1];
                  })
                  .map((value) => (!Number.isNaN(value) ? value : null));

              const teamTotalScore1 = () => {
                if (ballCount === 0) {
                  if (calculateNetScore[matchType]) {
                    return matrixNet?.reduce(smallestNumber);
                  }
                  return matrixGross?.reduce(smallestNumber);
                }
                if (ballCount === 1) {
                  if (calculateNetScore[matchType]) {
                    return sum2Smallest(matrixNet);
                  }
                  // return matrixGross?.map((row) => sum2Smallest(row));
                  return sum2Smallest(matrixGross);
                }
                return matrixGross?.reduce(sum1);
              };

              return (
                <React.Fragment key={uniqueId()}>
                  {final && checkPrevTeeTimeString && (
                    <Separator showTime={false} />
                  )}
                  {checkPrevTeamName && <Separator showTime={false} />}
                  <div
                    key={user.uid}
                    style={{
                      width: 44,
                      height: 44,
                      justifyContent: "center",
                      alignItems: "center",
                      display: "flex",
                      backgroundColor: backgroundHoles(),
                    }}
                    className="scorecardItem--result"
                  >
                    {quota ? quotaRes : res}
                  </div>
                  {totalBarDependsMatchType() &&
                    showTotal &&
                    checkNextTeamName &&
                    hideTotalForOnePlayer &&
                    ballCount !== 1 && (
                      <div
                        style={{
                          height: 48,
                          display: "flex",
                          justifyContent: "center",
                          alignItems: "center",
                          backgroundColor: "#EFEFEF",
                          width: 44,

                          fontFamily: "SF Pro Text",
                          fontWeight: 400,
                          fontSize: 24,
                          lineHeight: 18,
                          color: "rgba(30, 38, 46, 0.6)",
                          fontVariant: "small-caps",
                        }}
                      >
                        {quota
                          ? matrixQuota[index] ?? "-"
                          : teamTotalScore1()[index] ?? "-"}
                      </div>
                    )}
                  {showTwoBestBallDependsMatchType &&
                    hideTotalForOnePlayer &&
                    checkNextTeamName &&
                    ballCount === 1 && (
                      <Best2BestBallBar
                        showScoreByIndex
                        scoreByIndex={
                          calculateNetScore[matchType] ? matrixNet : matrixGross
                        }
                        holeIndex={index}
                        net={calculateNetScore[matchType]}
                      />
                    )}
                </React.Fragment>
              );
            })}

            {final && skins && (
              <SkinsBar
                dataByHole={skins[index]}
                index={index}
                skinsData={skins}
                carryOver={carryOver}
              />
            )}
          </div>
        ))}
      </div>
      <div>
        {hasOwnProperty && (
          <div>
            <div
              style={{
                display: "flex",
                justifyContent: "center",
                backgroundColor: "#ECF3FA",
              }}
            >
              <div className="scorecardItem--title-secondary">Tot</div>
            </div>
            <div
              style={{
                display: "flex",
                justifyContent: "center",
              }}
            >
              <div className="scorecardItem--title-secondary semibold">
                {holesResult || "-"}
              </div>
            </div>
          </div>
        )}

        {!teamsPlay && <Separator showTime={false} />}
        {users?.map((i, indx) => {
          const {
            checkPrevTeeTimeString,
            checkPrevTeamName,
            showTotal: showTeamTotal,
            checkNextTeamName,
            hideTotalForOnePlayer,
          } = checkPrevAndTotal(indx, i, users);

          const numOr0 = (n) => (!n ? 0 : n);

          const result = i.holes.reduce((acc, b) => acc + numOr0(b.score), 0);
          const quotaResult = i.holes.reduce(
            (acc, b) => acc + numOr0(b.quota),
            0,
          );

          const quotaTotalResult2 = addSign(quotaResult - i.quota);

          const groupedData = users.reduce((acc, curr) => {
            (acc[curr.teamName] = acc[curr.teamName] || []).push(curr);

            return acc;
          }, {});

          const getTotalSummaryForTeams = (forQuota) => {
            const matrixGross = groupedData[users[indx]?.teamName]?.map((uu) =>
              uu.holes.map((hole) => (forQuota ? hole.quota : hole.score)),
            );

            const matrixNet = groupedData[users[indx]?.teamName]?.map((uu) =>
              uu.holes.map((hole) => hole.netScore),
            );

            const sum2SmallestTotal = (arr) =>
              arr
                .reduce((acc, curr) => {
                  curr.forEach((value, arrIndex) => {
                    if (acc[arrIndex] === undefined) {
                      acc[arrIndex] = [];
                    }
                    if (value !== null) {
                      acc[arrIndex].push(value);
                    }
                  });
                  return acc;
                }, [])
                .map((column) => {
                  const sortedColumn = column.sort((a, b) => a - b);
                  return sortedColumn[0] + sortedColumn[1];
                })
                .map((value) => (!Number.isNaN(value) ? value : null));

            const smallestScoreArray = calculateNetScore[matchType]
              ? matrixNet?.reduce((r, a) =>
                  r.map((b, ind) => Math.min(a[ind], b) || null),
                )
              : matrixGross?.reduce((r, a) =>
                  r.map((b, ind) => Math.min(a[ind], b) || null),
                );

            const allUserQuota = groupedData[users[indx]?.teamName].reduce(
              (accumulator, currentUser) => accumulator + currentUser.quota,
              0,
            );

            const sum2SmallestArray = calculateNetScore[matchType]
              ? sum2SmallestTotal(matrixNet)
              : sum2SmallestTotal(matrixGross);

            const totalSum = () => {
              if (showBestBallTitle[matchType] && ballCount === 0) {
                return smallestScoreArray.reduce((a, b) => a + b, 0);
              }
              if (showBestBallTitle[matchType] && ballCount === 1) {
                return sum2SmallestArray.reduce((a, b) => a + b, 0);
              }
              return matrixGross.reduce(
                (acc, curr) =>
                  acc +
                  curr.reduce(
                    (acc2, curr2) =>
                      curr2 !== undefined ? acc2 + curr2 : acc2,
                    0,
                  ),
                0,
              );
            };

            return forQuota ? addSign(totalSum - allUserQuota) : totalSum();
          };

          return (
            <React.Fragment key={uniqueId()}>
              {final && checkPrevTeeTimeString && (
                <Separator showTime={false} />
              )}
              {checkPrevTeamName && <Separator showTime={false} />}
              <div
                style={{
                  width: 44,
                  height: 44,
                  justifyContent: "center",
                  alignItems: "center",
                  display: "flex",
                  backgroundColor: indx % 2 ? "white" : "#ECF3FA",
                }}
                key={uniqueId()} // TODO: fix unique IDs
                className="scorecardItem--result total"
              >
                {quota ? quotaTotalResult2 : result}
              </div>
              {totalBarDependsMatchType() &&
                showTeamTotal &&
                checkNextTeamName &&
                hideTotalForOnePlayer &&
                ballCount !== 1 && (
                  <div
                    style={{
                      height: 48,
                      display: "flex",
                      justifyContent: "center",
                      alignItems: "center",
                      backgroundColor: "#EFEFEF",
                      fontFamily: "SF Pro Text",
                      fontWeight: 700,
                      fontSize: 24,
                      lineHeight: 18,
                      color: "rgba(30, 38, 46, 0.6)",
                      fontVariant: "small-caps",
                    }}
                  >
                    {getTotalSummaryForTeams(quota && quota) || "-"}
                  </div>
                )}
              {showTwoBestBallDependsMatchType &&
                hideTotalForOnePlayer &&
                checkNextTeamName &&
                ballCount === 1 && (
                  <Best2BestBallBar
                    showTotal
                    holeIndex={indx}
                    scoreByIndex={
                      calculateNetScore[matchType]
                        ? groupedData[users[indx]?.teamName]?.map((uu) =>
                            uu.holes.map((hole) => hole.netScore),
                          )
                        : groupedData[users[indx]?.teamName]?.map((uu) =>
                            uu.holes.map((hole) => hole.score),
                          )
                    }
                  />
                )}
            </React.Fragment>
          );
        })}
        {final && skins && (
          <div
            style={{
              minHeight: 32,
              maxHeight: 32,
              width: "100%",
              backgroundColor: "rgba(30, 38, 46, 0.9)",
            }}
          />
        )}
      </div>
    </div>
  );
}

ScorecardItem.propTypes = {
  ballCount: PropTypes.number,
  users: PropTypes.arrayOf(
    PropTypes.shape({
      displayName: PropTypes.string,
      courseHandicap: PropTypes.number,
      uid: PropTypes.string,
      holes: PropTypes.arrayOf(
        PropTypes.shape({
          score: PropTypes.number,
          netScore: PropTypes.number,
          quota: PropTypes.number,
          grossToPar: PropTypes.number,
          netToPar: PropTypes.number,
          holePar: PropTypes.number,
        }),
      ),
      teamName: PropTypes.string,
      teeTimeString: PropTypes.string.isRequired,
    }),
  ).isRequired,
  onHoleClicked: PropTypes.func.isRequired,
  final: PropTypes.bool,
  hasOwnProperty: PropTypes.oneOfType([PropTypes.bool, PropTypes.func]),
  teeTimeTime: PropTypes.string,
  skins: PropTypes.oneOfType([
    PropTypes.bool,
    PropTypes.arrayOf(
      PropTypes.shape({
        birdieOrBetter: PropTypes.bool,
        cumulative: PropTypes.number,
        diff: PropTypes.number,
        min1: PropTypes.number,
        min2: PropTypes.number,
        parOrBetter: PropTypes.bool,
        perHole: PropTypes.number,
        scores: PropTypes.arrayOf(PropTypes.number),
        skinsWon: PropTypes.number,
        slice: PropTypes.func,
      }),
    ),
  ]),
  quota: PropTypes.bool,
  carryOver: PropTypes.bool,
  teamsPlay: PropTypes.bool,
  matchType: PropTypes.number,
  secondBetMatchType: PropTypes.objectOf([PropTypes.number, PropTypes.bool]),
  isSecondBetQuota: PropTypes.bool,
  currentHoleIndex: PropTypes.number.isRequired,
};

ScorecardItem.defaultProps = {
  final: false,
  hasOwnProperty: false,
  teeTimeTime: null,
  skins: false,
  quota: false,
  carryOver: true,
  teamsPlay: false,
  ballCount: 0,
  matchType: 0,
  secondBetMatchType: null,
  isSecondBetQuota: false,
};

export { ScorecardItem };
